export default __webpack_public_path__ + "static/media/funimation.88558b27.svg";